module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_8004.2c673d66.png";